import React from "react";

const Checkbox = ({
  className,
  name,
  defaultCheck,
  functionHandler,
  id,
  dataId,
  category
}) => {
  const checkedHandler = category => {
    functionHandler(category);
  };

  return (
    <li>
      <label className={className} htmlFor={id}>
        {name}
        <input
          type="checkbox"
          defaultChecked={defaultCheck}
          onChange={()=>checkedHandler(category)}
        />
        <span className="checkmark"></span>
      </label>
    </li>
  );
};

export default Checkbox;
